import React from "react";
import UserNavbar from "../../components/common/UserNavbar";
import { Navigate } from "react-router-dom";
import UserFooter from "../../components/common/UserFooter";
import { FaWhatsapp } from "react-icons/fa6";

const UserLayout = (props) => {
  const MessageButton = () => {
    const openMessageModal = () => {
      const phoneNumber = "918908651439";
      const whatsappUrl = `https://wa.me/${phoneNumber}`;
      window.open(whatsappUrl, "_blank");
    };

    return (
      <button
        className="fixed z-50 right-6 bottom-24 p-4 bg-[#25D366] rounded-full shadow-lg hover:bg-[#1DA851] hover:scale-105 ease-in-out duration-300 focus:outline-none transition-transform transform-gpu cursor-pointer"
        onClick={openMessageModal}
      >
        <FaWhatsapp size={32} color="#ffffff" />
      </button>
    );
  };

  return (
    <React.Fragment>
      <UserNavbar />
      {props.children}
      <UserFooter />

      <MessageButton />
    </React.Fragment>
  );
};

export default UserLayout;
